import {useEffect, useState} from 'react';

import {Checkbox, Typography} from '@mui/material';

import {ModuleMemberSettings} from '../../types/entities/ModuleType';

type LeaderboardVisibilityToggleProps = {
  currentIsCheckedSetting: boolean;
  saveCallback: (partialNewUserSettings: Partial<ModuleMemberSettings>) => void;
};

function LeaderboardVisibilityToggle({currentIsCheckedSetting, saveCallback}: LeaderboardVisibilityToggleProps) {
  const [isChecked, setIsChecked] = useState<boolean>(currentIsCheckedSetting || false);

  const [userIntervention, setUserIntervention] = useState<boolean>(false);

  const toggleIsChecked = () => {
    setIsChecked(!isChecked);
  };
  const saveChanges = async () => {
    await saveCallback({appearInLeaderboard: isChecked});
  };

  useEffect(() => {
    if (userIntervention) saveChanges();
  }, [isChecked]);

  return (
    <>
      <div className="flex flex-row items-center">
        <div className="flex flex-row items-center w-full">
          <Checkbox
            checked={isChecked}
            onChange={() => {
              setUserIntervention(true);
              toggleIsChecked();
            }}
            name={'leaderboard-visibility-toggle'}
            size="medium"
          />
          <Typography variant="subtitle1">{'Appear in leaderboard'}</Typography>
        </div>
      </div>
    </>
  );
}

export default LeaderboardVisibilityToggle;
